import { useState } from "react";
import { useQuery } from "react-query";

import { getCompanies } from "../../../../../MyApi/hr/companies";
import { getEmployes } from "../../../../../MyApi/sb/employes";
import { getBranches } from "../../../../../MyApi/sb/branches";

import LoadingSpinner from "../../../../UI/spinner";
import TaskList from "../TaskList";
import Modreator from "../moderator";
import Admin from "../admin";
import Employee from "../employee";
import icons from "../../../../../Data/icons";

import classes from "./addTask.module.css";

const AddTask = ({
  setLists,
  removeRow,
  setName,
  setStartDate,
  setEndDate,
  setRepeat,
  setRepeatPeriod,
  setLastRepeatPeriod,
  name,
  end_date,
  start_date,
  setCrmClientId,
  setCrmProjectId,
  setActive,
  setCompanyId,
  setAdmin,
  setBranchId,
  setEmploye,
  setModerator,
  listRow,
  lists,
  addRow,
  active,
  repeat,
  modreator,
  companyId,
  branchId,
}) => {
  const [isAdminOpen, setIsAdminOpen] = useState(false);
  const [isEmployeOpen, setIsEmployeOpen] = useState(false);
  const [isModeratorOpen, setIsModeratorOpen] = useState(false);
  const page = 0;

  const companyQuery = useQuery(["getcompany", page], () => getCompanies(page));
  const branchQuery = useQuery(
    ["getBranches", page, companyId],
    () => getBranches(page, companyId),
    {
      enabled: !!companyId,
    }
  );
  const employeQuery = useQuery(
    ["getEmployes", page, branchId],
    () => getEmployes(page, branchId),
    {
      enabled: !!branchId,
    }
  );

  const companies = companyQuery.data?.data || [];
  const branches = branchQuery.data?.data || [];
  const employes = employeQuery.data?.data || [];

  const AbcIcon = icons.abc;
  const City = icons.City;
  const Earth = icons.Earth;
  const ArrowDown = icons.ArrowDown;
  const ArrowUp = icons.ArrowUp;
  const CompanyIcon =icons.company
  const BranchIcon = icons.branch
const DateIcon = icons.date
  const handleNameChange = (e) => {
    const { value } = e.target;
    setName(value);
  };
  const handleCompanyChange = (e) => {
    setCompanyId(e.target.options[e.target.selectedIndex].id);
  };
  const handleBranchChange = (e) => {
    setBranchId(e.target.options[e.target.selectedIndex].id);
  };
  const handleStartDateChange = (e) => {
    const { value } = e.target;
    setStartDate(value);
  };
  const handleEndDateChange = (e) => {
    const { value } = e.target;
    setEndDate(value);
  };
  const handleRepeatChange = (e) => {
    const isChecked = e.target.checked;
    setRepeat(isChecked ? 1 : 0);
  };
  const handleRepeatPeriodChange = (e) => {
    const { value } = e.target;
    setRepeatPeriod(value);
  };
  const handleLastDatePeriodChange = (e) => {
    const { value } = e.target;
    setLastRepeatPeriod(value);
  };
  const handleActiveChange = (e) => {
    const isChecked = e.target.checked;
    setActive(isChecked ? 1 : 0);
  };

  const repeatPeriod = ["yearly", "monthly", "weekly"];


  return (
    <div className="row mb-3">
      <div className="col-lg-6">
        <div className={classes.formCard}>
          <div className={classes.formCol}>
            <label htmlFor=""> اختار الشركة</label>
            <div className={classes.iconInput}>
              <CompanyIcon />
            </div>
            {!companyQuery.data ? (
              <div>no data avalible</div>
            ) : (
              <select
                type="text"
                onChange={handleCompanyChange}
                className={classes.inputCustom}>
                <option value="">اختار الشركة</option>
                {companies.map((company) => (
                  <option id={company.id} value={company.name}>
                    {company.name}
                  </option>
                ))}
              </select>
            )}
          </div>

          <div className={classes.formCol}>
            <label htmlFor=""> اختار الفرع</label>
            <div className={classes.iconInput}>
              <BranchIcon />
            </div>
            {!branchQuery.data ? (
              <div>no data avalible</div>
            ) : (
              <select
                type="text"
                onChange={handleBranchChange}
                className={classes.inputCustom}>
                <option value="">اختار الفرع</option>
                {branches.map((branch) => (
                  <option id={branch.id} value={branch.name}>
                    {branch.name}
                  </option>
                ))}
              </select>
            )}
          </div>
          <div className={classes.formCol}>
            <label htmlFor="">الاسم </label>
            <div className={classes.iconInput}>
              <AbcIcon />
            </div>
            <input
              type="text"
              value={name}
              placeholder="ادخل اسم "
              onChange={handleNameChange}
              className={classes.inputCustom}
            />
          </div>
          <div className={classes.formCol}>
            <label htmlFor=""> تاريخ البداية</label>
            <div className={classes.iconInput}>
              <DateIcon />
            </div>
            <input
              type="date"
              value={start_date}
              placeholder="ادخل  تاريخ البداية"
              onChange={handleStartDateChange}
              className={classes.inputCustom}
            />
          </div>

          <div className={classes.formCol}>
            <label htmlFor=""> تاريخ الانتهاء</label>
            <div className={classes.iconInput}>
              <DateIcon />
            </div>
            <input
              type="date"
              value={end_date}
              placeholder="ادخل تاريخ  الانتهاء"
              onChange={handleEndDateChange}
              className={classes.inputCustom}
            />
          </div>

          <div className="d-flex mt-3 justify-content-between">
            <div className={classes.formCol}>
              <label
                htmlFor=""
                className={
                  active ? `${classes.active}` : `${classes.disActive}`
                }>
                {" "}
                {active === 1 ? " نشط" : "غير نشط"}{" "}
              </label>

              <label class="switch">
                <input
                  type="checkbox"
                  onChange={handleActiveChange}
                  checked={active}
                />
                <span class="slider round"></span>
              </label>
            </div>
            <div className={classes.formCol}>
              <label
                htmlFor="repeat"
                className={
                  repeat ? `${classes.active}` : `${classes.disActive}`
                }>
                {" "}
                {repeat === 1 ? " تكرار" : "لايوجد  تكرار"}{" "}
              </label>

              <label class="switch">
                <input
                  type="checkbox"
                  onChange={handleRepeatChange}
                  checked={repeat}
                />
                <span class="slider round"></span>
              </label>
            </div>
          </div>

          {repeat === 1 && (
            <>
              <div className={classes.formCol}>
                <label htmlFor="repeat-period">فتره التكرار</label>
                <div className={classes.iconInput}>
                  <City />
                </div>
                <select
                  type="number"
                  id="repeat-period"
             
                  placeholder="ادخل  فتره التكرار"
                  onChange={handleRepeatPeriodChange}
                  className={classes.inputCustom}>
                  {" "}
                  <option value="">اختار فتره التكرار</option>
                  {repeatPeriod.map((repeat, i) => (
                    <option key={i} value={repeat}>
                      {repeat}
                    </option>
                  ))}
                </select>
              </div>
              <div className={classes.formCol}>
                <label htmlFor="last-repeat-period">تاريخ اخر فتره تكرار</label>
                <div className={classes.iconInput}>
                  <City />
                </div>
                <input
                  type="date"
                  id="last-repeat-period"
                  placeholder=" تاريخ اخر فتره تكرار"
                  onChange={handleLastDatePeriodChange}
                  className={classes.inputCustom}
                />
              </div>
            </>
          )}
        </div>
      </div>
      <div className="col-lg-6">
        <div className={classes.formCard}>
          <div className={classes.formCol}>
            <label
              htmlFor="admin"
              className={classes.collapseLabel}
              onClick={() => setIsAdminOpen(!isAdminOpen)}>
              admin {isAdminOpen ? <ArrowUp /> : <ArrowDown />}
            </label>

            {!employeQuery.data ? (
              <div>no data available</div>
            ) : (
              <fieldset className={isAdminOpen ? classes.show : classes.hide}>
                {employes.map((employee) => (
                  <Admin
                    key={employee.id}
                    employee={employee}
                    classes={classes}
                    setAdmin={setAdmin}
                  />
                ))}
              </fieldset>
            )}
          </div>
          <div className={classes.formCol}>
            <label
              htmlFor="moderator"
              className={classes.collapseLabel}
              onClick={() => setIsModeratorOpen(!isModeratorOpen)}>
              {" "}
              moderator {isModeratorOpen ? <ArrowUp /> : <ArrowDown />}
            </label>

            {!employeQuery.data ? (
              <div>no data available </div>
            ) : (
              <fieldset
                className={isModeratorOpen ? classes.show : classes.hide}>
                {employes.map((employe) => (
                  <Modreator
                    key={employe.id}
                    employe={employe}
                    classes={classes}
                    setModerator={setModerator}
                  />
                ))}
              </fieldset>
            )}
          </div>
          <div className={classes.formCol}>
            <label
              htmlFor="employee"
              className={classes.collapseLabel}
              onClick={() => setIsEmployeOpen(!isEmployeOpen)}>
              {" "}
              employe {isEmployeOpen ? <ArrowUp /> : <ArrowDown />}
            </label>

            {!employeQuery.data ? (
              <div>no data available</div>
            ) : (
              <fieldset className={isEmployeOpen ? classes.show : classes.hide}>
                {employes.map((employee) => (
                  <Employee
                    key={employee.id}
                    employee={employee}
                    classes={classes}
                    setEmploye={setEmploye}
                  />
                ))}
              </fieldset>
            )}
          </div>
        </div>
        <div className={`${classes.formCard} mt-3`}>
          <div className={classes.formCol}>
            {listRow.map((row) => (
              <TaskList
                key={row.id}
                removeRow={removeRow}
                classes={classes}
                lists={lists}
                setLists={setLists}
                row={row}
              />
            ))}
            <button className={classes.addBtn} onClick={addRow}>
              اضافة قائمة
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddTask;
